<template>
<div>
        <v-select :items="typeOptions" v-model="element.type" :disabled="isTypeDisabled" label="Type" hide-details />

        <v-text-field v-if="isVisible('title')" v-model="element.title" label="Title" hide-details />
        <v-text-field v-if="isVisible('name')" v-model="element.name" label="Name" hide-details/>
        
        
        <div class="section-heading vertical-margin">Display</div>
        <v-slider v-model="element.width" 
                v-if="isVisible('width')" hide-details
                :label="widthLabel" :step="10" 
                class="mr-1"
        />
        <v-select v-if="isVisible('height')" :items="heightOptions" v-model="element.height" label="Height" hide-details />
        
        <ColourBar v-if="isVisible('background-colour')" :colours="['#eee', '#ddd', '#dff3fe']" v-model="element.background" label="Background Colour" />

        <div class="section-heading vertical-margin">Data</div>
        <v-text-field v-if="isVisible('table')" v-model="element.table" label="Table"/>   
        <v-textarea rows="3" v-if="isVisible('default-value-textarea')" v-model="element.defaultValue" label="Default Value"/>   
        <v-text-field v-if="isVisible('options')" v-model="element.options" label="Available Options" hide-details/>

        <div class="section-heading vertical-margin">Actions</div>
        <v-btn v-if="isVisible('add-column')" class="element-action-button" outline small color="primary" @click="buttonClicked('add-column')">Add Column</v-btn>
        <v-btn v-if="isVisible('save-section')" class="element-action-button" outline small color="primary" @click="buttonClicked('save-section')">Save Section</v-btn>
        <v-btn v-if="isVisible('clone-element')" class="element-action-button" outline small color="primary" @click="buttonClicked('clone-element')">Clone Element</v-btn>
</div>
</template>

<script>
import Utilities from '../helpers/Utilities'
import DataHelpers from '../helpers/DataHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import ArrayHelpers from '../helpers/ArrayHelpers'
import ColourBar from '../ui-elements/ColourBar'

export default {
    data() {
        return {
        
        }
    },

    components: {
        ColourBar,
    },
    
    props: {
        element: Object,
    },

    computed: {
        heightOptions() {
            return [
                {text: 'Small', value: 'S'},
                {text: 'Normal', value: null},
                {text: 'Large', value: 'L'},
            ]
        },
        typeOptions() {
            return [
                'Text', 'Section', 'Column', 'Checkbox', 'List', 'Html', 'Group'
            ]
        },
        isTypeDisabled() {
            return ArrayHelpers.textInArray(this.element.type, ['Section', 'Column'])
        },
        widthLabel() {
            return 'Width (' + (this.element.width || '00') + '%)'
        }

    },

    methods: {

        buttonClicked(eventString) {
            let payload = this.element
            this.$emit('button-click', eventString, payload)
        },

        isVisible(field) {
            let t = this.element.type
            let isLayout = (t == 'Column' || t == 'Section')

            if(field == 'title')
                return (t != 'Html')
            if(field == 'name')
                return (t != 'Column')
            if(field == 'options')
                return (t == 'List')
            if(field == 'width')
                return (t != 'Section')
            if(field == 'height')
                return (!isLayout && t != "Html")
            if(field == 'table')
                return (t == 'Section')
            if(field == 'height')
                return !isLayout
            if(field == 'save-section')
                return (t == 'Section')
            if(field == 'add-column')
                return (t == 'Section')
            if(field == 'clone-element')
                return (!isLayout)
            if(field == 'default-value-textarea')
                return (t == 'Html')
            if(field == 'background-colour')
                return isLayout
            return true
        },
        
        debouncedElementChanged: Utilities.debounce( (val) => {
                    AlertHelpers.showAlert('Element Changed')
                    console.log('Element Changed', val)
        }, 3000) 
    },

    created() {
        console.log('EditPanel > created')
    },

    watch: {    
        element: {
            handler: function (val, oldVal) {
                this.debouncedElementChanged(val)
            },
            deep: true
        },
    }
}
</script>

<style scoped>
    .section {
        padding:4px 8px;color:white;background-color: #1976D2;font-weight:600;
        border-radius:5px;text-transform: uppercase; margin: 10px 0;
    }   
    .element-action-button {
        width: 100%; margin: 0 0 5px 0;
    }
</style>




// WEBPACK FOOTER //
// EditPanel.vue?6f321a1d